import { Bar } from './BaseChart'
import { reactiveProp } from '@/mixins/chart'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import ChartJsPluginStreaming from 'chartjs-plugin-streaming'

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 190
    },
    classCanvas: {
      type: String,
      default: 'w-full'
    }
  },
  mounted() {
    const zeroCompensation = {
      renderZeroCompensation: function (chartInstance, d) {
        // get postion info from _view
        const view = d._view
        const context = chartInstance.chart.ctx

        // the view.x is the centeral point of the bar, so we need minus half width of the bar.
        const startX = view.x - view.width / 2
        // common canvas API, Check it out on MDN
        context.beginPath()
        // set line color, you can do more custom settings here.
        context.strokeStyle = '#aaaaaa'
        context.moveTo(startX, view.y)
        // draw the line!
        context.lineTo(startX + view.width, view.y)
        // bam！ you will see the lines.
        context.stroke()
      },

      afterDatasetsDraw: function (chart, easing) {
        // get data meta, we need the location info in _view property.
        const meta = chart.getDatasetMeta(0)
        // also you need get datasets to find which item is 0.
        const dataSet = chart.config.data.datasets[0].data
        meta.data.forEach((d, index) => {
          // for the item which value is 0, reander a line.
          if (dataSet[index] === 0) {
            this.renderZeroCompensation(chart, d)
          }
        })
      }
    }

    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.addPlugin(zeroCompensation)
    this.addPlugin(ChartJsPluginDataLabels)
    this.addPlugin(ChartJsPluginStreaming)

    this.onAnimationCompleteOptionsAppend()

    this.renderChart(
      this.chartData,
      this.options,
      this.height,
      this.classCanvas
    )
  },
  methods: {
    onAnimationCompleteOptionsAppend() {
      var _this = this
      this.options.animation = {
        onComplete: function () {
          _this.$emit('rawChart', _this.getBase64())
        }
      }
    },
    getBase64() {
      return this.$refs.canvas.toDataURL('image/png')
    }
  }
}
